function MembershipTerms() {
  return (
    <main className='px-6 py-12'>
      <div className='mx-auto max-w-[800px]'>
        <h1 className='mb-6 pb-4 text-center text-2xl font-bold'>
          紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）会員向け利用規約
        </h1>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１条（適用）</h2>
          <p className='mb-4'>
            本規約は、株式会社紀陽銀行（以下「当行」といいます。）が提供する「紀陽ＤＸプラットフォーム（Ｋｅｙ{'　'}Ｘ）」（以下「本サービス」といいます。）における会員登録機能および会員向けサービスの利用条件を定めるものです。
          </p>
          <p className='mb-4'>
            本規約は、本サービスの利用者のうち、当行所定の方法により会員登録を行った個人または法人（以下「会員」といいます。）に適用されます。
          </p>
          <p className='mb-4'>
            なお、本規約に定めのない事項については、別途定める共通利用規約が適用されます。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第２条（会員登録）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              本サービスの利用希望者は本規約に同意の上、当行所定の方法により会員登録を行うものとします。
            </li>
            <li className='mb-2'>
              会員登録に際しては、以下の情報を登録するものとします。
              <ol className='mt-2 list-none pl-4'>
                <li>（１）企業名</li>
                <li>（２）氏名</li>
                <li>（３）住所</li>
                <li>（４）メールアドレス</li>
              </ol>
            </li>
            <li className='mb-2'>
              会員は、メールアドレスおよびパスワードを用いてログインするものとします。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第３条（登録情報の管理）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>会員は、登録情報を正確かつ最新の内容に保つものとします。</li>
            <li className='mb-2'>
              登録情報に変更が生じた場合、会員は速やかに変更手続きを行うものとします。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第４条（アカウント管理）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              会員は、自己の責任においてログイン情報を管理するものとします。
            </li>
            <li className='mb-2'>
              ログイン情報の不正使用等による損害については、会員が責任を負うものとします。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第５条（権利の譲渡禁止）</h2>
          <p className='mb-4'>
            会員は、本サービスの利用権を第三者に譲渡または共有してはならないものとします。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第６条（禁止行為）</h2>
          <p className='mb-2'>
            利用者は、本サービスの利用にあたり、以下の行為を禁止します。以下の行為をおこなう利用者については、当行から本サービスの利用をお断りすることがあります。
          </p>
          <ul className='mb-4 list-disc pl-6'>
            <li>法令または公序良俗に違反する行為</li>
            <li>第三者の権利を侵害する行為</li>
            <li>本サービスの他の利用者又は第三者に不利益、損害又は不快感を与える行為</li>
            <li>誹謗中傷または名誉毀損に該当する行為</li>
            <li>個人情報の不正な共有・取得</li>
            <li>なりすまし行為</li>
            <li>無断広告や営業活動</li>
            <li>本サービスの運営を妨害する行為</li>
            <li>虚偽又は誤解を招くような内容を含む情報等を、掲載等し又は登録する行為</li>
            <li>地域課題解決に明らかに関係のない目的をもって行われたものと当行が判断した行為</li>
            <li>その他、当行が不適切と判断した行為</li>
          </ul>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第７条（反社会的勢力の排除）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              利用者は、現在および将来にわたり、自己および自己の役員等が反社会的勢力（暴力団、暴力団員、暴力団関係企業、総会屋その他暴力、威力、詐欺的手法を利用して経済的利益を追求する者をいいます。）及びこれらに準ずる者に該当せず、またこれらと関係を有しないことを表明し、保証するものとします。
            </li>
            <li className='mb-2'>
              利用者は、自らまたは第三者を利用して、暴力的または不当な要求行為その他これに準ずる行為を行わないものとします。
            </li>
            <li className='mb-2'>
              当行は、利用者が前二項に違反したと認めた場合、何らの通知または催告を要することなく、本サービスの利用停止または利用契約の解除を行うことができます。
            </li>
            <li className='mb-2'>
              前項の措置により利用者に損害が生じても、当行は責任を負わないものとします。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第８条（利用停止・登録取消等）</h2>
          <p className='mb-4'>
            当行は、利用者が本規約もしくは別途定める共通利用規約に違反したとき、またはサービスの運営に支障をきたす行為を行ったと当行が判断したときは、事前の何らの通知なく、利用停止もしくは登録取消、または契約の解除を行うことができます。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第９条（退会）</h2>
          <ol className='mb-4 list-decimal pl-6'>
            <li className='mb-2'>
              会員は、退会を希望する場合、当行に対し、所定の方法により申し出るものとします。
            </li>
            <li className='mb-2'>
              当行が当該会員のアカウントを削除した時点で、退会は完了するものとします。
            </li>
          </ol>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１０条（通知・連絡）</h2>
          <p className='mb-4'>
            当行から会員への通知は、第２条２項により登録のあったメールアドレスへの送信、サービスにかかるｗｅｂサイトへの掲載その他当行が適当であると判断する方法により行います。
          </p>
        </section>

        <section className='mb-8'>
          <h2 className='mb-4 text-xl font-semibold'>第１１条（準拠法・管轄）</h2>
          <p className='mb-4'>本規約は日本法を準拠法とします。</p>
          <p className='mb-4'>
            本サービスに関して生じた紛争については、当行の本店所在地を管轄する裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
        </section>

        <p className='mt-8'>以上</p>
      </div>
    </main>
  );
}

export default MembershipTerms;
